import { render, staticRenderFns } from "./Scout.vue?vue&type=template&id=704e9865&lang=pug&"
import script from "./Scout.vue?vue&type=script&lang=js&"
export * from "./Scout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports